import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Settings2 } from "lucide-react";
import { api } from "@/lib/api";
import { SOCIAL_PLATFORMS, SocialIcon, OpenLink } from "@/lib/socials";

export function BrandShortcutBar({ onManage }) {
  const [links, setLinks] = useState(null);
  useEffect(() => { api.get("/admin/socials").then(({ data }) => setLinks(data.brand || {})).catch(() => setLinks({})); }, []);
  if (!links) return null;
  const saved = SOCIAL_PLATFORMS.filter((p) => links[p.key]);
  const copy = (v, l) => navigator.clipboard.writeText(v).then(() => toast.success(`${l} copied`)).catch(() => toast.error("Copy blocked by the browser"));
  return (
    <div data-testid="brand-shortcut-bar" className="rounded-2xl border border-white/8 bg-surface p-4 flex flex-wrap items-center gap-2">
      <span className="text-[10px] uppercase tracking-[0.25em] text-gold mr-2">Your accounts</span>
      {saved.length ? saved.map((p) => (
        <span key={p.key} data-testid={`brand-shortcut-${p.key}`} className="flex items-center gap-1 rounded-full border border-white/10 pl-3 pr-1 py-1">
          <SocialIcon k={p.key} size={12} />
          <button data-testid={`brand-shortcut-copy-${p.key}`} onClick={() => copy(links[p.key], p.label)} title="Copy handle" className="text-xs text-text-main hover:text-gold flex items-center gap-1">
            {links[p.key]} <Copy size={10} className="text-text-muted" />
          </button>
          <OpenLink k={p.key} value={links[p.key]} testId={`brand-shortcut-open-${p.key}`} size={10} />
        </span>
      )) : <span data-testid="brand-shortcut-empty" className="text-xs text-text-muted">No brand accounts saved yet.</span>}
      <button data-testid="brand-shortcut-manage" onClick={onManage} className="ml-auto flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-text-muted hover:text-gold">
        <Settings2 size={12} /> {saved.length ? "Edit accounts" : "Add accounts"}
      </button>
    </div>
  );
}
